import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js'

// Product Media Gallery - Full Screen Gallery with PhotoSwipe
// https://photoswipe.com/v5/docs/getting-started/
const initProductMediaGallerySwipe = () => {
    document.querySelectorAll('#product-page .product-carousel').forEach(($carousel) => {
        const lightbox = new PhotoSwipeLightbox({
            gallery: $carousel,
            children: 'a',
            pswpModule: './photoswipe.esm.min.js'
        })
        lightbox.init()
    })
}
initProductMediaGallerySwipe()

// Product Media Gallery - Sticky position on scroll (only in desktop)
const initProductMediaGallerySitcky = () => {
    document.querySelectorAll('.sticky-carousel').forEach(($carousel) => {
        window.addEventListener('scroll', () => {
            if (window.scrollY > 20) {
                const navbarHeight = document.querySelector('#shopify-section-navbar.fixed-top').clientHeight || 0
                $carousel.style.position = 'sticky'
                $carousel.style.top = `${navbarHeight + 20}px`
            }
        })
    })
}
initProductMediaGallerySitcky()

// Handle Ingredients
const handleIngredients = async () => {
    const $ingredientsBlock = document.querySelector('.product-block-ingredients')

    if ($ingredientsBlock) {
        const response = await fetch('https://cdn.shopify.com/s/files/1/0016/8896/1122/t/136/assets/ingredients.json')
        const data = await response.json()
        // console.log(data)

        document.querySelectorAll('[data-ingredient-row]').forEach(($row) => {
            const ingredientData = data[$row.dataset.ingredientRow]

            if (ingredientData) {
                $row.querySelector('[data-ingredient-description]').setAttribute('title', ingredientData.description)
                // eslint-disable-next-line no-new
                new bootstrap.Tooltip($row.querySelector('[data-ingredient-description]'), {
                    placement: 'top'
                })

                $row.querySelector('[data-ingredient-origin]').textContent = ingredientData.origin
                $row.querySelector('[data-ingredient-score]').innerHTML = `
                    <span class="score-badge badge" style="background-color: ${ingredientData.score > 2 ? '#FF9E18' : '#019D4F'}">
                        ${ingredientData.score}
                    </span>
                `
            }
        })
    }
}
handleIngredients()

// YotPo reviews on product page - small fixes
const $yotooMainWidget = document.querySelector('.yotpo.yotpo-main-widget')
if ($yotooMainWidget) {
    $yotooMainWidget.classList.add('container')
}

// Recharge widget
const initRechargeWidgetType = () => {
    document.querySelectorAll('[name="recharge-widget-type"]').forEach(input => {
        input.addEventListener('change', () => {
            const finalPriceEl = input.closest('#product-page-content').querySelector('[data-product-price]')

            if (input.value === 'one-time') {
                document.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'none'
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.productPrice)
                document.querySelector('#sticky-atc-recharge-widget-type-one-time').click()
            } else if (input.value === 'subscription') {
                document.querySelector('#recharge-widget-schedule-list-wrapper').style.display = 'block'
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.subPrice)
                document.querySelector('#sticky-atc-recharge-widget-type-subscription').click()
            } else if (input.value === 'trial') {
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.productPrice)
                history.replaceState(null, '', input.dataset.url)
            } else if (input.value === 'trial-subscription') {
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.subPrice)
                history.replaceState(null, '', input.dataset.url)
            }

            if (input.value === 'trial' || input.value === 'trial-subscription') {
                document.querySelector('#product-page-content').style.opacity = '.25'
                // document.querySelector('#product-page .product-carousel').style.opacity = '.25'

                fetch(window.location.href)
                    .then(response => response.text())
                    .then(data => {
                        const parser = new DOMParser()
                        const newDocument = parser.parseFromString(data, 'text/html')

                        document.querySelector('#product-page-content')
                            .replaceWith(newDocument.querySelector('#product-page-content'))
                        document.querySelector('#product-page .product-carousel')
                            .replaceWith(newDocument.querySelector('#product-page .product-carousel'))
                        document.querySelector('#product-sticky-atc .container')
                            .replaceWith(newDocument.querySelector('#product-sticky-atc .container'))

                        initRechargeWidgetType()
                        initRechargeWidgetSchedule()
                        initStickyAtcRechargeWidgetType()
                        initStickyAtcBtnHandler()
                    })
            }
        })
    })
}
initRechargeWidgetType()

const initRechargeWidgetSchedule = () => {
    document.querySelectorAll('[name="recharge-widget-schedule"]').forEach(range => {
        range.addEventListener('input', () => {
            let days = range.dataset.days.split(',')
            days = days.filter(item => item)

            const selectedDaysOption = days[days.length - range.value + 1]

            document.querySelector('[data-deliver-every-text]').textContent = selectedDaysOption
            document.querySelector('#sticky-atc-btn-msg [data-sub] span').textContent = selectedDaysOption
        })
    })
}
initRechargeWidgetSchedule()

const initStickyAtcRechargeWidgetType = () => {
    document.querySelectorAll('[name="sticky-atc-recharge-widget-type"]').forEach(input => {
        input.addEventListener('change', () => {
            const finalPriceEl = input.closest('#product-sticky-atc').querySelector('[data-product-price]')

            if (input.value === 'one-time') {
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.productPrice)
                document.querySelector('#sticky-atc-btn-msg [data-sub]').style.display = 'none'
                document.querySelector('#sticky-atc-btn-msg [data-one-time]').style.display = 'block'
            } else if (input.value === 'subscription') {
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.subPrice)
                document.querySelector('#sticky-atc-btn-msg [data-sub]').style.display = 'block'
                document.querySelector('#sticky-atc-btn-msg [data-one-time]').style.display = 'none'
            } else if (input.value === 'trial') {
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.productPrice)
                document.querySelector('input#recharge-widget-type-trial').click()
            } else if (input.value === 'trial-subscription') {
                finalPriceEl.textContent = window.formatMoney(finalPriceEl.dataset.subPrice)
                document.querySelector('input#recharge-widget-type-trial-subscription').click()
            }
        })
    })
}
initStickyAtcRechargeWidgetType()

const initStickyAtcBtnHandler = () => {
    document.querySelectorAll('#product-sticky-atc .btn-atc').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const selectedType = btn.closest('#product-sticky-atc').querySelector('[name="sticky-atc-recharge-widget-type"]:checked').value

            if (selectedType === 'subscription' || selectedType === 'trial-subscription') {
                e.preventDefault()

                document.querySelector('#product-page-content').scrollIntoView()
            }
        })
    })
}
initStickyAtcBtnHandler()

document.querySelectorAll('#sticky-atc-btn-msg [data-one-time] b').forEach(fakeBtn => {
    fakeBtn.addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector('#product-page-content').scrollIntoView()
    })
})

// Update product images in the gallery when switching subscription/one-time
if (window.location.href.indexOf('promo') != -1) {
    document.querySelectorAll('[name="recharge-widget-type"]').forEach(radio => {
        radio.addEventListener('change', () => {
            const carousel = bootstrap.Carousel.getOrCreateInstance('.product-carousel')
            if (radio.value === 'one-time') {
                carousel.to(1)
            } else {
                carousel.to(0)
            }
        })
    })
}

// New Product "Free Trial" template
(() => {
    if (!document.querySelector('#product-trial-step-1')) {
        return
    }

    document.querySelectorAll('.product-page-free-trial [data-step]').forEach(btn => {
        btn.addEventListener('click', (e) => {
            const steps = document.querySelector('#product-trial-steps')
            const activeStep = btn.dataset.step
    
            steps.querySelectorAll('li').forEach(item => {
                item.classList.remove('active')
                item.removeAttribute('aria-current')
            })
            steps.querySelector(`li:nth-child(${activeStep})`).classList.add('active')
            steps.querySelector(`li:nth-child(${activeStep})`).setAttribute('aria-current', 'page')
    
            document.querySelectorAll('.product-trial-step-wrapper').forEach(wrapper => {
                wrapper.style.display = 'none'
            })
            document.querySelector(`#product-trial-step-${activeStep}`).style.display = 'block'
            
            window.scrollTo({ top: 0, behavior: 'smooth' })
        })

    })

    document.querySelector('.product-page-free-trial #recharge-widget-schedule').addEventListener('change', () => {
        const range = document.querySelector('#recharge-widget-schedule')
        
        let days = range.dataset.days.split(',')
        days = days.filter(item => item)

        const selectedDaysOption = days[days.length - range.value + 1]

        document.querySelector('[data-text-step-3-deliver]').textContent = selectedDaysOption
    })

    const checkoutBtn = document.querySelector('.product-page-free-trial [data-btn-checkout]')

    checkoutBtn.addEventListener('click', async () => {
        checkoutBtn.innerHTML = `
            <div 
                class="spinner-border spinner-border-sm" 
                role="status"
                style="width: 1.2rem; height: 1.2rem">
                <span class="visually-hidden">Loading...</span>
            </div>
        `

        await fetch('/cart/clear.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' }
        })
        
        const rangeElement = document.querySelector('[name="recharge-widget-schedule"]')
        const subPlansValueIds = rangeElement.dataset.valueIds.split(',')
        subPlansValueIds.filter(item => item)
        const sellingPlan = subPlansValueIds[subPlansValueIds.length - rangeElement.value]

        const formData = {
            items: [{
                id: Number(checkoutBtn.dataset.variantId),
                quantity: 1,
                selling_plan: sellingPlan
            }]
        }

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData)
        })

        window.location.href = '/checkout'

    })

})();